@if (currentQuestion && currentTemplate) {
  <div class="grid-x">
    <div class="cell small-12 margin-bottom">
      Please Set Data Options:
    </div>
    <div class="cell small-12">
      <label>
        <span class="label-text">Context Target</span>
        <input type="text" id="contextTarget" placeholder="$..." [(ngModel)]="currentQuestion.contextTarget">
      </label>
    </div>
    <div class="cell small-12">
      <label>
        <span class="label-text">Initial Data Context Target<help-text [helpText]="'You <b>must</b> test compile the expression in order for the initial data context target value to be saved!'"></help-text></span>
        <rules-editor placeholder="$..." [type]="'Initial Data Context Target'" [rule]="currentQuestion.initialDataContextTargetRule" [expression]="currentQuestion.initialDataContextTarget" (updateRule)="initialTargetUpdated($event)"></rules-editor>
      </label>
    </div>
    @if (getConfiguration(currentQuestion.type); as configType) {
      @if (configType.controllers) {
        <div class="cell small-12">
          <controller-selector [(config)]="currentQuestion.config" [controllers]="configType.controllers"></controller-selector>
        </div>
      }
    }
    <div class="cell small-12">
      <ng-template dynamic-component-loader
        [componentName]="getConfigurationType(currentQuestion.type) + 'dataconfig'"
        [componentData]="currentQuestion"
        [componentContext]="currentTemplate.context"
        [selectedState]="selectedState"
        isEdit="true">
      </ng-template>
    </div>
  </div>
}